import md from '@/routes/middlewares';

import AdminMain from '@/views/admin/AdminMain.vue';

import aquassistBilling from './aquassistBilling';
import management from './management';
import configuration from './configuration';
import advancedConfiguration from './advancedConfiguration';

const administration = {
    path: '/administration',
    name: 'administration',
    component: AdminMain,
    meta: {
        middlewares: [
            md.auth,
            md.accessControl,
        ],
        // Just an example to show how to use, has to be changed to correct value
        // atLeastNeededRoles: ["administrator", "management"],
        // everyNeededPermissions: ["members.view"]
    },
    children: [
        management,
        configuration,
        advancedConfiguration,
        aquassistBilling,
    ],
};

export default administration;
